import { render, staticRenderFns } from "./SubmissionWizard.vue?vue&type=template&id=d56c69fa"
import script from "./SubmissionWizard.vue?vue&type=script&lang=js"
export * from "./SubmissionWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports